import { NgModule } from '@angular/core';
import { OverzichtComponent } from './pages/overzicht/overzicht.component';
import { SharedModule } from '@shared/shared.module';
import { AdministratieModule } from '../administratie/administratie.module';

@NgModule({
  declarations: [OverzichtComponent],
  imports: [SharedModule, AdministratieModule],
  exports: [OverzichtComponent],
  providers: [],
})
export class DashboardModule {}
